React = require('react')

{Render} = require('./render')

# helper

name_cmp = (a, b) ->
  return a.name < b.name

# connect

ConnectScreen = React.createClass
  getInitialState: () ->
    return {
      name: @props.defaultName
      blocked: false
    }

  connect: (e) ->
    e.preventDefault()
    @setState({blocked: true})
    @props.connect(@state.name)

  handleNameChange: (e) ->
    @setState({name: e.target.value})

  render: () ->
    return React.createElement("div", null,
      React.createElement("form", {"onSubmit": (@connect)}, """
        Name: 
""", React.createElement("input", {"type": "input", "ref": ((i) -> i?.focus()), "value": (@state.name), "onChange": (@handleNameChange), "disabled": (@state.blocked)}),
        React.createElement("input", {"type": "submit", "value": "Connect", "disabled": (@state.blocked || @state.name.length == 0)})
      )
    )

# global lobby

GameEntry = React.createClass
  render: () ->
    peers = @props.peers.map (peer) ->
      React.createElement("li", {"key": (peer.id)}, (peer.name))

    return React.createElement("div", null,
      React.createElement("h3", null, (@props.name)),
      React.createElement("ul", null, (peers)),
      React.createElement("input", {"type": "button", "value": "Join", "onClick": (@props.join)})
    )

GameList = React.createClass
  render: () ->
    games = @props.games.map (game) =>
      return React.createElement(GameEntry, {"key": (game.id), "name": (game.name), "peers": (game.peers), "join": (@props.join.bind(null, game.id))})

    if games.length > 0
      return React.createElement("div", null,
        (games)
      )
    else
      return React.createElement("div", null, "No open games")

GameCreator = React.createClass
  getInitialState: () ->
    return {
      title: ''
    }

  handleTitleChange: (e) ->
    @setState({title: e.target.value})

  create: (e) ->
    e.preventDefault()
    @props.create(@state.title)

  render: () ->
    return React.createElement("div", null,
      React.createElement("form", {"onSubmit": (@create)},
        React.createElement("input", {"type": "input", "value": (@state.title), "onChange": (@handleTitleChange)}),
        React.createElement("input", {"type": "submit", "value": "Create", "disabled": (@state.title.length == 0)})
      )
    )

GameSelectionScreen = React.createClass
  getInitialState: () ->
    @props.namespace.on 'room_changed', () =>
      @setState({games: @gameList()})

    return {
      games: @gameList()
    }

  gameList: () ->
    games = []

    for room_id, room of @props.namespace.rooms
      peers = []

      for peer_id, peer of room.peers
        peers.push({
          id: peer_id
          name: peer.status.name
          pending: peer.pending
        })

      peers.sort(name_cmp)

      games.push({
        id: room_id
        name: room.status.name
        peers: peers
      })

    games.sort(name_cmp)

    return games

  render: () ->
    return React.createElement("div", null,
      React.createElement("h2", null, "Create new game"),
      React.createElement(GameCreator, {"create": (@props.create)}),
      React.createElement("h2", null, "Join game"),
      React.createElement(GameList, {"games": (@state.games), "join": (@props.join)})
    )

# game lobby

PeerList = React.createClass
  render: () ->
    peers = @props.peers.map (peer) ->
      return React.createElement("li", {"key": (peer.id)}, (peer.name))

    if peers.length > 0
      return React.createElement("ul", null, (peers))
    else
      return React.createElement("div", null, "No other players, yet")

LobbyScreen = React.createClass
  getInitialState: () ->
    update_cb = () =>
      @setState({peers: @peerList()})

    @props.game.on('peer_joined', update_cb)
    @props.game.on('peer_status_changed', update_cb)
    @props.game.on('peer_left', update_cb)

    @props.game.on 'status_changed', (status) =>
      @setState({name: status.name})

    return {
      peers: @peerList()
      name: @props.game.signaling.status.name || ''
    }

  peerList: () ->
    peers = []

    for peer_id, peer of @props.game.peers
      peers.push({
        id: peer_id
        name: peer.status('name')
      })

    peers.sort(name_cmp)

    return peers

  render: () ->
    return React.createElement("div", null,
      React.createElement("h2", null, "Game"), """
      Name: """, (@props.game.signaling.status.name),
      React.createElement("h2", null, "Other Players"),
      React.createElement(PeerList, {"peers": (@state.peers)}),
      React.createElement("br", null),
      React.createElement("input", {"type": "button", "value": "Start", "onClick": (@props.start)}),
      React.createElement("input", {"type": "button", "value": "Leave", "onClick": (@props.leave)})
    )

# game screen

PlayerList = React.createClass
  render: () ->
    players = @props.players.map (player) ->
      return React.createElement("li", {"key": (player.id)},
        React.createElement("span", {"style": ({
          display: 'inline-block'
          backgroundColor: player.color
          width: '0.5em'
          height: '0.5em'
          border: '1px solid black'
        })}), " ", (player.name)
      )

    return React.createElement("ul", null,
      (players)
    )

GameScreen = React.createClass
  componentDidMount: () ->
    @game_render = new Render(@refs.draw, @props.game)

  componentWillUnmount: () ->
    @game_render.close()

  render: () ->
    players = @props.players.map (player, i) =>
      return {
        id: player.id
        name: player.name
        color: Render.COLORS[i]
      }

    return React.createElement("div", null,
      React.createElement("h2", null, "Players"),
      React.createElement(PlayerList, {"players": (players)}),
      React.createElement("h2", null, "Game"),
      React.createElement("canvas", {"ref": "draw"}),
      React.createElement("br", null), React.createElement("br", null),
      React.createElement("input", {"type": "button", "value": "Leave", "onClick": (@props.leave)})
    )

# error screen

ErrorScreen = React.createClass
  render: () ->
    return React.createElement("div", null,
      (@props.error), React.createElement("br", null),
      React.createElement("input", {"type": "button", "value": "OK", "onClick": (@props.continue)})
    )

# fatal screen

FatalScreen = React.createClass
  render: () ->
    return React.createElement("div", null, (@props.error))

# module stuff

module.exports = {
  ConnectScreen: ConnectScreen
  GameSelectionScreen: GameSelectionScreen
  LobbyScreen: LobbyScreen
  GameScreen: GameScreen
  ErrorScreen: ErrorScreen
  FatalScreen: FatalScreen
}
